import AeronyxWebsite from './AeronyxWebsite';

function App() {
  return <AeronyxWebsite />;
}

export default App;
